import request from "src/utils/request";
import { toastify } from "src/utils/toast";
import {
  loadingBtnAction,
  loginAction,
  setSubscription,
  setEtsyShops,
} from "src/redux/actions/userActions";
import {
  loadEtsyListingsByStatus,
  getAllProducts,
} from "src/pages/products/request";
import { isVipsUserType } from "src/utils/userTypes";
import { preloadVipsDashboard } from "src/utils/preloadDashboard";
import { getCatalogsList } from "src/pages/catalog/request";
import { persistCanvaOAuthState } from "src/pages/store/storeOAuth";
import { signupSubscribePath } from "./signupLink";
import { getAuthUserExtras } from "src/utils/apod";
import { rememberAuthPortal } from "src/utils/authPortal";
import { takeSellerOrderDeepLinkPath } from "src/pages/orders/utils/orderDeepLink";

export const registerUser = async (dispatch, payload, setStep) => {
  dispatch(loadingBtnAction(true));
  try {
    const res = await request.post("/register", payload);

    if (res) {
      const token = res.data.data.token;

      localStorage.setItem("token", token);
      localStorage.setItem("registered", true);
      localStorage.removeItem("userFormData");

      setStep("subscribe");
      dispatch(loadingBtnAction(false));
    }
  } catch (e) {
    dispatch(loadingBtnAction(false));
    toastify("error", e.response.data.message);
  }
};

export const sendToSubscribe = (navigate, token) => {
  if (token) {
    localStorage.setItem("token", token);
  }
  localStorage.setItem("registered", true);
  navigate(signupSubscribePath());
  toastify("warning", "Please subscribe before logging in");
};

export const googleLogin = async (dispatch, navigate, data) => {
  try {
    const res = await request.post("/login/google", data);

    if (res) {
      var response = res["data"];
      var data_filter = response["data"];
      const userData = data_filter.user || data_filter;
      const token = data_filter["token"];
      const oauth = data_filter["oauth"];
      const expiresIn = data_filter["expiresIn"];
      const subscription = data_filter["subscription"];
      const etsy_shops = userData["etsy_shops"] || data_filter["etsy_shops"] || [];
      const etsyStoreConnected = etsy_shops.length > 0 ? 1 : 0;
      const image = userData.image ?? "";

      dispatch(
        loginAction(
          token,
          userData.id,
          userData.name,
          userData.email,
          image,
          userData.UserType,
          getAuthUserExtras(userData, data_filter),
        )
      );
      dispatch(setSubscription(subscription));
      if (etsy_shops && etsy_shops.length > 0) {
        dispatch(setEtsyShops(etsy_shops));
      }

      localStorage.setItem("token", token);
      localStorage.setItem("oAuth", oauth);
      localStorage.setItem("expiresIn", expiresIn);
      localStorage.setItem("etsyStore", etsyStoreConnected);
      localStorage.setItem("registered", false);
      persistCanvaOAuthState({ ...data_filter, user: userData });

      if (userData?.UserType === "Seller") {
        getAllProducts(dispatch);
        if (etsyStoreConnected) {
          loadEtsyListingsByStatus(dispatch, "active");
        }
      }

      rememberAuthPortal(userData?.UserType);

      if (isVipsUserType(userData?.UserType)) {
        await preloadVipsDashboard();
        getCatalogsList(dispatch);
      }

      const sellerOrderPath = takeSellerOrderDeepLinkPath(userData?.UserType);

      if (sellerOrderPath) {
        navigate(sellerOrderPath);
      } else if (userData?.UserType === "AdminAccessGuard") {
        navigate("/dashboard/user");
      } else if (
        userData?.UserType === "PrintProvider" ||
        isVipsUserType(userData?.UserType)
      ) {
        navigate("/dashboard/orders");
      } else {
        navigate("/dashboard/app");
      }
      dispatch(loadingBtnAction(false));
    }
  } catch (e) {
    dispatch(loadingBtnAction(false));
    const status = e?.response?.status;

    if (status === 402) {
      sendToSubscribe(navigate, e?.response?.data?.data?.token);
      return;
    }

    const message =
      e?.response?.data?.message ||
      e?.message ||
      "Google login failed. Please try again.";
    toastify("error", message);
  }
};
